import { NgModule } from '@angular/core';
import { ConcatenateIdAndNamePipe } from './concatenate-id-and-name.pipe';
import { DecodeTextPipe } from './decode-text.pipe';
import { HighlightPipe } from './highlight.pipe';
import { ParseDatePipe } from './parse-date.pipe';
import { ToAgnosticDateStringPipe } from './to-agnostic-date-string.pipe';
import { ToClassStringPipe } from './to-class-string.pipe';
import { ToLabelStringPipe } from './to-label-string.pipe';


@NgModule({
  declarations: [
    ConcatenateIdAndNamePipe,
    DecodeTextPipe,
    HighlightPipe,
    ParseDatePipe,
    ToClassStringPipe,
    ToLabelStringPipe,
  ],
  exports: [
    ConcatenateIdAndNamePipe,
    DecodeTextPipe,
    HighlightPipe,
    ParseDatePipe,
    ToAgnosticDateStringPipe,
    ToClassStringPipe,
    ToLabelStringPipe,
  ],
  imports: [
    ToAgnosticDateStringPipe,
  ],
})
export class PipesModule { }
